/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceReferenceRequest
 */
export interface DeviceReferenceRequest {
    /**
     *
     * @type {string}
     * @memberof DeviceReferenceRequest
     */
    deviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof DeviceReferenceRequest
     */
    deviceArchiveId?: number;
    /**
     *
     * @type {boolean}
     * @memberof DeviceReferenceRequest
     */
    cascadeToChildDevices?: boolean;
}

/**
 * Check if a given object implements the DeviceReferenceRequest interface.
 */
export function instanceOfDeviceReferenceRequest(
    value: object,
): value is DeviceReferenceRequest {
    return true;
}

export function DeviceReferenceRequestFromJSON(
    json: any,
): DeviceReferenceRequest {
    return DeviceReferenceRequestFromJSONTyped(json, false);
}

export function DeviceReferenceRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceReferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        deviceArchiveId:
            json["deviceArchiveId"] == null
                ? undefined
                : json["deviceArchiveId"],
        cascadeToChildDevices:
            json["cascadeToChildDevices"] == null
                ? undefined
                : json["cascadeToChildDevices"],
    };
}

export function DeviceReferenceRequestToJSON(
    value?: DeviceReferenceRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        deviceArchiveId: value["deviceArchiveId"],
        cascadeToChildDevices: value["cascadeToChildDevices"],
    };
}
